const webBiLogger = require('web-bi-logger').default

const {
  BI_SOURCE,
  BI_VIEWER_ENDPOINT,
  BI_ERROR_ENDPOINT,
  workerLoggerFactory
} = require('dbsm-common/src/bi/bi')
const { getAppUrl } = require('dbsm-common/src/worker/getUrl')
const getAppVersion = require('dbsm-common/src/getAppVersion')

const APP_NAME = 'dbsm-viewer-app'

const biDefaults = {
  src: BI_SOURCE,
  ver: getAppVersion(getAppUrl(APP_NAME)),
  app_name: APP_NAME,
  app_id: 'dataBinding'
}

const setupBiLogger = () =>
  workerLoggerFactory(
    webBiLogger
      .factory({ endpoint: BI_VIEWER_ENDPOINT })
      .updateDefaults(biDefaults)
  )

const setupErrorBiLogger = () =>
  workerLoggerFactory(
    webBiLogger
      .factory({ endpoint: BI_ERROR_ENDPOINT })
      .updateDefaults(biDefaults)
      .updateDefaults({ evid: 10 })
  )

module.exports.setupBiLogger = setupBiLogger
module.exports.setupErrorBiLogger = setupErrorBiLogger



// WEBPACK FOOTER //
// ./bi/setupBiLogger.js